import React from 'react';
import { ClockIcon, GlobeIcon, MailIcon, MessageCircleIcon } from 'lucide-react';
import { Seo } from '../components/Seo';
import { MaskText, SectionLabel } from '../components/ui/Reveal';
import { ContactForm } from '../components/ContactForm';
import { Newsletter } from '../components/Newsletter';
import { brand, contact, links, whatsappUrl } from '../data/site';
const socials = [{
  label: 'Instagram',
  href: links.instagram
}, {
  label: 'Facebook',
  href: links.facebook
}, {
  label: 'TikTok',
  href: links.tiktok
}, {
  label: 'Pinterest',
  href: links.pinterest
}, {
  label: 'Linktree',
  href: links.linktree
}];
export function ContactPage() {
  return <>
      <Seo title="Contact — Book a Consultation | Morvix Graphics" description="Start a project with Morvix Graphics. Book a consultation for brand identity, logo design, packaging or web design. 24-hour support, serving clients worldwide." path="/contact" data-id="element-679" data-mp="eyuudpxx2u3y" />

      <section className="bg-surface pb-16 pt-32 sm:pb-24 sm:pt-44" aria-label="Contact" data-id="element-680" data-mp="1qfukqg0peyvc">
        <div className="mx-auto w-full max-w-container px-5 sm:px-8" data-id="element-681" data-mp="qykiyif2mw4x">
          <SectionLabel data-id="element-682" data-mp="n0eghml9n2pt">Contact</SectionLabel>
          <h1 className="mt-6 max-w-5xl font-display text-[11vw] font-extrabold uppercase leading-[0.86] tracking-tightest sm:text-[7vw] lg:text-[5.4vw]" data-id="element-683" data-mp="i007o2buboqq">
            <MaskText text="Let’s Create|Something Worth|Remembering." data-id="element-684" data-mp="d0du1rs3o6he" />
          </h1>
          <p className="mt-8 max-w-2xl text-base leading-relaxed text-muted sm:text-lg" data-id="element-685" data-mp="82udumbudjmt">
            Have an idea, a brand that needs a new direction, or a project that deserves better
            design? Let’s talk.
          </p>

          <div className="mt-14 grid gap-12 border-t border-line pt-12 lg:grid-cols-[1.25fr_0.75fr]" data-id="element-686" data-mp="3vcsgcu69yx3c">
            <div data-id="element-687" data-mp="3qdpc3by4cuwf">
              <h2 className="label mb-8 text-muted" data-id="element-688" data-mp="3lgpe7obfayge">Project request</h2>
              <ContactForm data-id="element-689" data-mp="3lfxmioky5kve" />
            </div>

            <aside className="space-y-8" data-id="element-690" data-mp="3gh46opi6ths2">
              <div className="border border-line p-6" data-id="element-691" data-mp="3gie6bj4ouy0t">
                <h2 className="label text-muted" data-id="element-692" data-mp="36tgz4cezu8z5">Direct</h2>
                <ul className="mt-5 space-y-4" data-id="element-693" data-mp="36w33622oe6cm">
                  <li data-id="element-694" data-mp="3btd16644rqc2">
                    <a href={`mailto:${contact.email}`} className="flex items-start gap-3 text-sm transition-colors hover:text-brand" data-id="element-695" data-mp="3buo82esvhe7e">
                      <MailIcon className="mt-0.5 h-4 w-4 shrink-0 text-brand" aria-hidden="true" data-id="element-696" data-mp="31vff9p9qu5mm" />
                      {contact.email}
                    </a>
                  </li>
                  <li data-id="element-697" data-mp="3uijh5ldji3u6">
                    <a href={whatsappUrl} target="_blank" rel="noreferrer noopener" className="flex items-start gap-3 text-sm transition-colors hover:text-brand" data-id="element-698" data-mp="3uit4f1779ww6">
                      <MessageCircleIcon className="mt-0.5 h-4 w-4 shrink-0 text-brand" aria-hidden="true" data-id="element-699" data-mp="ccwvoodknbhu" />
                      <span data-id="element-700" data-mp="21uljvbtpw0nh">
                        {contact.whatsappDisplay}
                        <span className="block text-muted" data-id="element-701" data-mp="1ww0iva6n5cxz">WhatsApp — fastest reply</span>
                      </span>
                    </a>
                  </li>
                  <li className="flex items-start gap-3 text-sm text-muted" data-id="element-702" data-mp="2bk5009q1pgen">
                    <ClockIcon className="mt-0.5 h-4 w-4 shrink-0 text-brand" aria-hidden="true" data-id="element-703" data-mp="26n4uq110shol" />
                    {brand.hours}
                  </li>
                  <li className="flex items-start gap-3 text-sm text-muted" data-id="element-704" data-mp="1dx62xxvfy6g8">
                    <GlobeIcon className="mt-0.5 h-4 w-4 shrink-0 text-brand" aria-hidden="true" data-id="element-705" data-mp="1dz92p9mebdy5" />
                    {brand.serviceModel}
                  </li>
                </ul>
              </div>

              <div className="border border-line p-6" data-id="element-706" data-mp="1nxos985ryf5j">
                <h2 className="label text-muted" data-id="element-707" data-mp="348j1izgceuuy">Follow</h2>
                <ul className="mt-5 grid gap-2" data-id="element-708" data-mp="2zahe62bvw9do">
                  {socials.map(social => <li key={social.label} data-id="element-709" data-mp="18tdm7ld25so2">
                      <a href={social.href} target="_blank" rel="noreferrer noopener" className="text-sm underline decoration-line underline-offset-4 transition-colors hover:text-brand hover:decoration-brand" data-id="element-710" data-mp="18uoyyaohearb">
                        {social.label}
                      </a>
                    </li>)}
                </ul>
              </div>

              <div className="bg-brand p-6 text-white" data-id="element-711" data-mp="1wqj9n1r2yxkv">
                <p className="label text-white/70" data-id="element-712" data-mp="1wp88l9p0s3xg">What happens next</p>
                <ol className="mt-4 space-y-3 text-sm" data-id="element-713" data-mp="21ikuhc2bdwmi">
                  <li data-id="element-714" data-mp="25k61whw2xipb">01 — We read your brief and reply within 24 hours.</li>
                  <li data-id="element-715" data-mp="25lh8epgwt4k4">02 — A short consultation to align on goals and scope.</li>
                  <li data-id="element-716" data-mp="2agmp99vgft1c">03 — A clear proposal, timeline and quote.</li>
                </ol>
              </div>
            </aside>
          </div>
        </div>
      </section>

      <Newsletter data-id="element-717" data-mp="2pmk4fubrsojm" />
    </>;
}